import { create } from "../../../../../common/utils/zustand_state_manager";
import { ObraChecklistServicoDropDown } from "../../../domain/models/obra_checklist_servico_dropdown";
import { ObraAreaChecklistDropDown } from "../../../domain/models/obra_area_checklist_dropdown";

/**
 * useObrasCadastroAreaFilters
 */

type State = {
  area: string;
  status: number;
  obraAreaChecklists: ObraAreaChecklistDropDown[] | undefined;
  obraChecklistServicos: ObraChecklistServicoDropDown[] | undefined;
  excOrIncObraChecklistServicos: ObraChecklistServicoDropDown[] | undefined;
};

type Actions = {};

export const useObrasCadastroareaFilters = create<State & Actions>((set) => ({
  area: '',
  status: 2,
  obraAreaChecklists: undefined,
  obraChecklistServicos: undefined,
  excOrIncObraChecklistServicos: undefined,
}));

export const initialObrasCadastroFilters: Partial<State> = {
  area: '',
  status: 2,
};